/* RESPONSIBLE TEAM: team-standalone */
import ApplicationAdapter from '../application';

export default class EnvironmentAdapter extends ApplicationAdapter {
  pathForType(): string {
    return 'standalone/environments';
  }
}
